// Shade picker: draws the shade on the gallery photo
(function () {
  if (window.scShadeReady) return;
  window.scShadeReady = true;

  var HEX = {
    'woven charcoal': '#4A4846',
    'natural linen': '#D5CAB4',
    'raw linen': '#CBBFA6',
    'flax weave': '#C8B998',
    'old gold': '#B89A5A',
    oatmeal: '#DCD2BE',
    biscotti: '#D8C3A0',
    natural: '#D5CAB4',
    charcoal: '#4A4846',
    ivory: '#EEE7D7',
    white: '#F3F0E8',
    black: '#262523',
    mondo: '#A9A59B',
    taupe: '#B7A893',
  };
  var SHAPES = ['Tapered drum', 'Coolie', 'Drum'];
  var LIGHT = ['Oatmeal', 'White', 'Ivory', 'Raw Linen', 'Natural Linen', 'Natural', 'Biscotti'];
  var SVGNS = 'http://www.w3.org/2000/svg';
  // Mirrors the "Fabric Shades" delivery profile
  var SHIP = [[1900, 2000], [3900, 2500], [5900, 3500], [7000, 4500], [Infinity, 5900]];

  function shadeShipping(grams) {
    for (var i = 0; i < SHIP.length; i++) {
      if (grams <= SHIP[i][0]) return SHIP[i][1];
    }
    return null;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function money(cents) {
    var d = cents / 100;
    return '$' + (d % 1 ? d.toFixed(2) : String(d)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function colourOf(name) {
    var n = (name || '').toLowerCase();
    var keys = Object.keys(HEX);
    for (var i = 0; i < keys.length; i++) {
      if (n.indexOf(keys[i]) > -1) {
        return { name: keys[i].replace(/\b\w/g, function (c) { return c.toUpperCase(); }), hex: HEX[keys[i]] };
      }
    }
    return { name: name || 'Natural', hex: '#DCD2BE' };
  }
  function dark(hex) {
    var n = parseInt(hex.slice(1), 16);
    return ((n >> 16) & 255) * 0.3 + ((n >> 8) & 255) * 0.59 + (n & 255) * 0.11 < 110;
  }
  function shade(hex, f) {
    var n = parseInt(hex.slice(1), 16);
    var r = Math.round(((n >> 16) & 255) * f), g = Math.round(((n >> 8) & 255) * f), b = Math.round((n & 255) * f);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  // Same-size shades share one size option
  function buildSizes(shades) {
    var map = {};
    var list = [];
    shades.forEach(function (s) {
      var d = s.d || {};
      if (!d.bot || !d.h || SHAPES.indexOf(d.shape) < 0) return;
      var key = d.shape + '|' + d.top + '|' + d.bot + '|' + d.h;
      var size = map[key];
      if (!size) {
        var tall = /\btall\b/i.test(s.title);
        size = map[key] = {
          key: key, shape: d.shape, top: d.top || d.bot, bot: d.bot, h: d.h,
          label: Math.round(d.bot / 10) + ' cm' + (tall ? ' tall' : ''),
          name: Math.round(d.bot / 10) + 'cm ' + (tall ? d.shape + ' Tall' : d.shape).replace(/\b\w/g, function (c) { return c.toUpperCase(); }),
          colours: [],
        };
        list.push(size);
      }
      s.v.forEach(function (v) {
        var c = colourOf(s.single ? s.title : v.t);
        size.colours.push({ id: v.id, name: c.name, hex: c.hex, price: v.p, available: v.a, weight: v.w || 0, url: s.url });
      });
    });
    list.forEach(function (z) {
      z.available = z.colours.some(function (c) { return c.available; });
    });
    return list.filter(function (z) { return z.available; }).sort(function (a, b) { return a.bot - b.bot || a.h - b.h; });
  }

  function fitOf(size, rec) {
    var r = size.bot / rec;
    if (r < 0.85) return { key: 'small', label: 'Small' };
    if (r > 1.2) return { key: 'wide', label: 'Too wide' };
    if (r > 1.08) return { key: 'roomy', label: 'Fuller' };
    return { key: 'good', label: 'Good fit' };
  }

  function geometry(fit, size) {
    var k = fit.k * 1000, cx = fit.cx * 1000, edge = fit.sb * 1000 - 4;
    var tw = size.top * k, bw = size.bot * k, hh = size.h * k, ty = edge - hh;
    var tr = Math.max(3, tw * 0.045), br = Math.max(7, bw * 0.04);
    function r(n) { return Math.round(n * 10) / 10; }
    var d = 'M' + r(cx - tw / 2) + ' ' + r(ty) + 'Q' + r(cx) + ' ' + r(ty + 2 * tr) + ' ' + r(cx + tw / 2) + ' ' + r(ty) +
      'L' + r(cx + bw / 2) + ' ' + r(edge) + 'Q' + r(cx) + ' ' + r(edge + 2 * br) + ' ' + r(cx - bw / 2) + ' ' + r(edge) + 'Z';
    var rim = 'M' + r(cx - bw / 2) + ' ' + r(edge) + 'Q' + r(cx) + ' ' + r(edge + 2 * br) + ' ' + r(cx + bw / 2) + ' ' + r(edge);
    return { d: d, rim: rim, cx: r(cx), ty: r(ty), rx: r(tw / 2), ry: r(tr) };
  }

  function shadeSvg(id) {
    return '<defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="0">' +
      '<stop offset="0" stop-color="#000" stop-opacity=".2"/><stop offset=".3" stop-color="#000" stop-opacity="0"/>' +
      '<stop offset=".6" stop-color="#fff" stop-opacity=".07"/><stop offset="1" stop-color="#000" stop-opacity=".24"/></linearGradient></defs>' +
      '<ellipse data-r="top"/><path data-r="body"/><path data-r="shine" fill="url(#' + id + ')"/>' +
      '<path data-r="rim" fill="none" stroke="#000" stroke-opacity=".14" stroke-width="2"/>';
  }

  function paintSvg(svg, g, col) {
    var q = function (k) { return svg.querySelector('[data-r="' + k + '"]'); };
    var top = q('top');
    top.setAttribute('cx', g.cx);
    top.setAttribute('cy', g.ty);
    top.setAttribute('rx', g.rx);
    top.setAttribute('ry', g.ry);
    top.setAttribute('fill', dark(col.hex) ? '#E6E0D3' : shade(col.hex, 0.78));
    q('body').setAttribute('d', g.d);
    q('body').setAttribute('fill', col.hex);
    q('shine').setAttribute('d', g.d);
    q('rim').setAttribute('d', g.rim);
  }

  function Picker(root) {
    var data;
    try {
      data = JSON.parse(root.querySelector('[data-scp-shade-data]').textContent);
    } catch (e) {
      return;
    }
    this.root = root;
    this.data = data;
    this.fit = data.fit;
    this.info = root.closest('product-info') || document;
    this.input = root.querySelector('[data-scp-shade-input]');
    this.ui = root.querySelector('[data-scp-shade-ui]');
    this.sizes = buildSizes(data.shades || []);
    if (!this.sizes.length || !this.fit || !this.fit.k) return;
    var rec = this.fit.rec || 310;
    var best = this.sizes.slice().sort(function (a, b) {
      var da = Math.abs(a.bot - rec), db = Math.abs(b.bot - rec);
      return da - db || SHAPES.indexOf(a.shape) - SHAPES.indexOf(b.shape);
    })[0];
    this.state = { size: best.key, colour: this.firstColour(best) };
    this.showRender = true;
    // cut 0: bare-base photo, nothing to hide
    this.cut = this.fit.cut != null ? this.fit.cut : Math.min(98, (this.fit.sb * 1000 + 3) / 10);
    this.origin = this.fit.cx * 100 + '% ' + (this.fit.fy || 0.95) * 100 + '%';
    // Wide: draw on the gallery. Phone: in the picker
    this.wide = window.matchMedia('(min-width: 750px)');
    this.build();
    this.mountGallery();
    this.render();
    root.hidden = false;
    this.wireCart();
    var self = this;
    var onChange = function () {
      self.paintGallery();
      self.labels();
    };
    if (this.wide.addEventListener) this.wide.addEventListener('change', onChange);
    else if (this.wide.addListener) this.wide.addListener(onChange);
  }

  // Shrink photo + shade just enough to fit
  Picker.prototype.fitZoom = function (size) {
    var g = geometry(this.fit, size);
    var k = this.fit.k * 1000, cx = this.fit.cx * 1000, fy = (this.fit.fy || 0.95) * 1000, m = 40;
    var top = g.ty - g.ry, half = (size.bot * k) / 2, z = 1;
    if (top < m) z = Math.min(z, (fy - m) / (fy - top));
    if (cx - half < m) z = Math.min(z, (cx - m) / half);
    if (cx + half > 1000 - m) z = Math.min(z, (1000 - m - cx) / half);
    return Math.max(0.4, z);
  };

  Picker.prototype.zoom = function (el, z) {
    if (!el) return;
    el.style.transition = 'transform .25s ease';
    el.style.transformOrigin = this.origin;
    el.style.transform = z < 0.999 ? 'scale(' + z.toFixed(3) + ')' : '';
    // Soften photo edges so shadows don't end in a line
    if (el.tagName === 'IMG') el.classList.toggle('scp-zoomed', z < 0.999);
  };

  Picker.prototype.size = function () {
    var key = this.state.size;
    return this.sizes.filter(function (z) { return z.key === key; })[0] || this.sizes[0];
  };
  // Default to a light shade, like the photos
  Picker.prototype.firstColour = function (size) {
    var ok = size.colours.filter(function (x) { return x.available; });
    var light = ok.filter(function (x) { return LIGHT.indexOf(x.name) > -1; }).sort(function (a, b) {
      return LIGHT.indexOf(a.name) - LIGHT.indexOf(b.name);
    })[0];
    var c = light || ok[0];
    return c ? c.id : null;
  };
  Picker.prototype.colour = function () {
    var id = this.state.colour, size = this.size();
    return size.colours.filter(function (c) { return c.id === id; })[0] || size.colours[0];
  };

  // Overlay the drawing on the matching gallery slide
  Picker.prototype.mountGallery = function () {
    var src = this.fit.src;
    var slides = this.info.querySelectorAll('media-gallery [data-media-id]');
    var slide = null;
    for (var i = 0; i < slides.length; i++) {
      var im = slides[i].querySelector('.product__media img');
      if (im && (im.currentSrc || im.src || '').indexOf(src) > -1) {
        slide = slides[i];
        break;
      }
    }
    if (!slide) return;
    var media = slide.querySelector('.product__media');
    var box = slide.querySelector('.product-media-container') || media;
    if (!media || !box) return;
    this.slide = slide;
    this.img = media.querySelector('img');

    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('viewBox', '0 0 1000 1000');
    svg.setAttribute('class', 'scp-render__svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.innerHTML = shadeSvg('scpShadeG');
    media.appendChild(svg);
    this.svg = svg;

    var note = document.createElement('div');
    note.className = 'scp-render__note';
    note.innerHTML = '<span data-r="note"></span><button type="button" data-r="toggle"></button>';
    box.appendChild(note);
    this.note = note;
    var self = this;
    note.querySelector('button').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      self.showRender = !self.showRender;
      self.paintGallery();
    });
  };

  Picker.prototype.paintGallery = function () {
    if (!this.svg) return;
    var on = this.showRender && this.wide.matches;
    paintSvg(this.svg, geometry(this.fit, this.size()), this.colour());
    var z = on ? this.fitZoom(this.size()) : 1;
    this.svg.style.display = on ? '' : 'none';
    this.zoom(this.svg, z);
    this.note.hidden = !this.wide.matches;
    if (this.img) {
      this.img.style.clipPath = on && this.cut ? 'inset(' + this.cut + '% 0 0 0)' : '';
      this.zoom(this.img, z);
      this.img.parentElement.classList.toggle('scp-render-on', on);
    }
    this.note.querySelector('[data-r="note"]').textContent = on ? 'Shade is a render' : 'Original photo';
    var t = this.note.querySelector('[data-r="toggle"]');
    t.textContent = on ? 'Show photo' : 'Show your lamp';
    t.setAttribute('aria-label', on ? 'Show the original photo' : 'Show the base with your chosen shade');
  };

  // Bring the render slide into view in the gallery
  Picker.prototype.showSlide = function () {
    if (!this.slide) return;
    var gallery = this.info.querySelector('media-gallery');
    var id = this.slide.dataset.mediaId;
    if (!this.slide.classList.contains('is-active') && gallery) {
      var first = this.info.querySelector('[data-scp-views] [data-scp-view=""]');
      var firstSlide = this.info.querySelector('media-gallery [data-media-id]');
      if (first && firstSlide === this.slide) first.click();
      else if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(id, false);
    }
  };

  Picker.prototype.build = function () {
    this.ui.innerHTML =
      '<div class="scp-shade__head"><h3 class="scp-shade__title">Choose a shade</h3>' +
      '<p class="scp-shade__sub">Drawn to scale on this base</p></div>' +
      '<div class="scp-shade__top"><div class="scp-shade__mini">' +
      '<img src="' + esc(this.data.img) + '" alt="" loading="lazy"' + (this.cut ? ' style="clip-path: inset(' + this.cut + '% 0 0 0)"' : '') + '>' +
      '<svg viewBox="0 0 1000 1000" role="img" data-scp-shade-mini>' + shadeSvg('scpShadeM') + '</svg></div>' +
      '<div class="scp-shade__sum"><p class="scp-shade__picked"><span data-scp-shade-name></span><b data-scp-shade-price></b></p>' +
      '<p class="scp-shade__meta" data-scp-shade-height></p>' +
      '<p class="scp-shade__note">Shade is a render, drawn to scale</p></div></div>' +
      '<div class="scp-shade__group"><p class="scp-shade__lbl" id="scpShapeLbl">Shape</p><div class="scp-shade__shapes" role="group" aria-labelledby="scpShapeLbl" data-scp-shade-shapes></div></div>' +
      '<div class="scp-shade__group"><p class="scp-shade__lbl" id="scpSizeLbl">Size</p><div class="scp-shade__sizes" role="group" aria-labelledby="scpSizeLbl" data-scp-shade-sizes></div></div>' +
      '<div class="scp-shade__group"><p class="scp-shade__lbl" id="scpColLbl">Colour <b data-scp-shade-colname></b></p><div class="scp-shade__cols" role="group" aria-labelledby="scpColLbl" data-scp-shade-cols></div></div>' +
      '<p class="scp-shade__verdict" data-scp-shade-verdict aria-live="polite"></p>' +
      '<p class="scp-shade__total" data-scp-shade-total></p>' +
      '<p class="scp-shade__ship" data-scp-shade-ship></p>';
    var self = this;
    this.ui.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-act]');
      if (!b || b.disabled) return;
      var act = b.dataset.act, val = b.dataset.val;
      if (act === 'shape') {
        var cur = self.size();
        if (cur.shape === val) return;
        var rec = self.fit.rec || 310;
        var pick = self.sizes.filter(function (z) { return z.shape === val; }).sort(function (a, b2) {
          return Math.abs(a.bot - rec) - Math.abs(b2.bot - rec);
        })[0];
        self.state = { size: pick.key, colour: self.firstColour(pick) };
      } else if (act === 'size') {
        var z = self.sizes.filter(function (x) { return x.key === val; })[0];
        var keep = z.colours.filter(function (c) { return c.available && c.name === self.colour().name; })[0];
        self.state = { size: val, colour: keep ? keep.id : self.firstColour(z) };
      } else if (act === 'colour') {
        self.state.colour = Number(val);
      }
      self.showRender = true;
      self.render();
      if (self.wide.matches) self.showSlide();
    });
  };

  Picker.prototype.render = function () {
    var self = this, size = this.size(), col = this.colour(), rec = this.fit.rec || 310;
    var q = function (sel) { return self.ui.querySelector(sel); };
    q('[data-scp-shade-height]').textContent = 'Lamp about ' + Math.round((this.fit.h - 25 + size.h) / 10) * 10 + ' mm tall';
    var mini = q('[data-scp-shade-mini]');
    paintSvg(mini, geometry(this.fit, size), col);
    var mz = this.fitZoom(size);
    this.zoom(mini, mz);
    this.zoom(q('.scp-shade__mini img'), mz);
    mini.setAttribute('aria-label', 'This base with the ' + size.name + ' shade in ' + col.name.toLowerCase() + ', drawn to scale');
    q('[data-scp-shade-name]').textContent = size.name + ', ' + col.name;
    q('[data-scp-shade-price]').textContent = '+' + money(col.price);
    q('[data-scp-shade-colname]').textContent = col.name;

    var shapes = SHAPES.filter(function (s) { return self.sizes.some(function (z) { return z.shape === s; }); });
    var icons = {
      'Tapered drum': 'M12 4h20l5 20H7z',
      Coolie: 'M17 4h10l11 20H6z',
      Drum: 'M9 4h26v20H9z',
    };
    q('[data-scp-shade-shapes]').innerHTML = shapes.map(function (s) {
      var on = s === size.shape;
      return '<button type="button" data-act="shape" data-val="' + esc(s) + '" aria-pressed="' + on + '">' +
        '<svg width="40" height="24" viewBox="0 0 44 28" aria-hidden="true" focusable="false"><path d="' + icons[s] + '" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>' +
        '<span>' + esc(s) + '</span></button>';
    }).join('');
    q('[data-scp-shade-sizes]').innerHTML = this.sizes.filter(function (z) { return z.shape === size.shape; }).map(function (z) {
      var f = fitOf(z, rec), on = z.key === size.key;
      return '<button type="button" data-act="size" data-val="' + esc(z.key) + '" aria-pressed="' + on + '">' +
        '<span>' + esc(z.label) + '</span><small class="scp-shade__fit scp-shade__fit--' + f.key + '">' + f.label + '</small></button>';
    }).join('');
    q('[data-scp-shade-cols]').innerHTML = size.colours.map(function (c) {
      var on = c.id === col.id;
      return '<button type="button" data-act="colour" data-val="' + c.id + '" aria-pressed="' + on + '" aria-label="' + esc(c.name + (c.available ? '' : ', sold out')) + '"' + (c.available ? '' : ' disabled') + '>' +
        '<span style="background:' + c.hex + '"></span></button>';
    }).join('');

    var f = fitOf(size, rec);
    var recCm = Math.round(rec / 10);
    var verdict = {
      good: ['Good fit.', 'We recommend about a ' + recCm + 'cm shade for this base.'],
      roomy: ['A fuller look.', 'Suits a larger side table.'],
      small: ['Small for this base.', 'The lampholder may show below the shade.'],
      wide: ['Too wide for this base.', 'It will look top-heavy. Try about ' + recCm + 'cm.'],
    }[f.key];
    var v = q('[data-scp-shade-verdict]');
    v.className = 'scp-shade__verdict scp-shade__verdict--' + f.key;
    v.innerHTML = '<b>' + verdict[0] + '</b> ' + verdict[1];
    var total = this.data.price + col.price;
    q('[data-scp-shade-total]').innerHTML = 'Lamp total <b>' + money(total) + '</b> <span>base ' + money(this.data.price) + ' + shade ' + money(col.price) + '</span>';
    var qtyEl = this.info.querySelector('.quantity__input');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    var ship = col.weight ? shadeShipping(col.weight * qty) : null;
    var shipEl = q('[data-scp-shade-ship]');
    shipEl.hidden = !ship;
    shipEl.innerHTML = ship
      ? (qty > 1 ? 'Shades ship separately' : 'Shade ships in its own box') + ': <b>+' + money(ship) + ' delivery</b>, including on orders over $499.'
      : '';

    this.input.dataset.scpAddon = col.available ? String(col.id) : '';
    this.input.checked = !!col.available;
    this.total = total;
    this.paintGallery();
    this.labels();
  };

  // Main button: base + shade. Second: base only
  Picker.prototype.labels = function () {
    var main = this.info.querySelector('.product-form__submit');
    if (!main || main.disabled) return;
    var span = main.querySelector('span');
    var narrow = main.offsetWidth < 300;
    var text = (narrow ? 'Add lamp · ' : 'Add lamp to cart · ') + money(this.total);
    if (span && span.textContent.trim() !== text) span.textContent = text;
    var base = this.info.querySelector('[data-scp-base-only]');
    if (base) base.textContent = (narrow ? 'Base only · ' : 'Add base only · ') + money(this.data.price);
    var fb = document.querySelector('.scp-float__price b');
    if (fb) fb.textContent = money(this.total);
    var fl = document.querySelector('.scp-float__long');
    if (fl) fl.textContent = 'Add lamp to cart';
    var fs = document.querySelector('.scp-float__short');
    if (fs) fs.textContent = 'Add lamp · ' + money(this.total);
  };

  Picker.prototype.wireCart = function () {
    var self = this;
    var main = this.info.querySelector('.product-form__submit');
    if (!main) return;
    var wrap = main.parentNode;
    if (!wrap.querySelector('[data-scp-base-only]')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'button button--secondary button--full-width scp-shade__base';
      b.setAttribute('data-scp-base-only', '');
      b.textContent = 'Add base only · ' + money(this.data.price);
      wrap.appendChild(b);
      b.addEventListener('click', function () {
        if (main.disabled) return;
        var was = self.input.checked;
        self.input.checked = false;
        main.click();
        setTimeout(function () {
          self.input.checked = was;
        }, 50);
      });
      this.labels();
    }
    var qtyEl = this.info.querySelector('.quantity__input');
    if (qtyEl) qtyEl.addEventListener('change', function () {
      self.render();
    });
    var span = main.querySelector('span');
    if (span && window.MutationObserver) {
      new MutationObserver(function () {
        self.labels();
      }).observe(span, { childList: true, characterData: true, subtree: true });
    }
  };

  function init() {
    document.querySelectorAll('[data-scp-shade]').forEach(function (root) {
      if (!root.dataset.ready) {
        root.dataset.ready = '1';
        new Picker(root);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
